import React, { useState } from "react";
import {
  FlyoutContainer,
  FlyoutIconWrapper,
  FlyoutMenuContainer
} from "./styles";
import { IconBaseProps } from "icons/Icon";

interface FlyoutIcon {
  icon: React.FC<IconBaseProps>;
  handler: (e: React.MouseEvent<HTMLDivElement>) => void;
  key: any;
  disabled?: boolean;
}

interface FlyoutMenuProps {
  anchor: "left" | "right";
  open?: boolean;
  icon: React.FC<IconBaseProps>;
  iconColor: string;
  iconList: FlyoutIcon[];
  iconListColor: string;
}

const FlyoutMenu: React.FC<FlyoutMenuProps> = ({
  anchor = "left",
  open: openOverride,
  icon: Icon,
  iconColor,
  iconList = [] as FlyoutIcon[],
  iconListColor
}) => {
  const controlled = typeof openOverride === "boolean";
  const [open, setOpen] = useState(false);
  const visible = controlled ? openOverride : open;
  const handleToggle = () => !controlled && setOpen(!open);

  return (
    <FlyoutMenuContainer>
      <div onClick={handleToggle}>
        <Icon color={iconColor} size={24} />
      </div>
      <FlyoutContainer
        className={visible ? "visible" : ""}
        anchor={anchor}
        count={iconList.length}
      >
        {iconList.map(({ icon: Icon, handler, key, disabled }) => (
          <FlyoutIconWrapper
            onClick={e => {
              if (disabled) return e.stopPropagation();
              handler(e);
            }}
            key={key}
          >
            <Icon
              size={24}
              style={{
                color: iconListColor,
                opacity: disabled ? 0.4 : 1,
                cursor: disabled ? "not-allowed" : "pointer"
              }}
            />
          </FlyoutIconWrapper>
        ))}
      </FlyoutContainer>
    </FlyoutMenuContainer>
  );
};

export default FlyoutMenu;
